export default __webpack_public_path__ + "static/media/teste.2c6d60f6.svg";